import { utils } from '../utils.js';
import { beads } from '../beads.js';
import { menu } from '../menu.js';
import { modes } from '../modes.js';
import { settings } from '../settings.js';

export const userimage = {};


userimage.initialize = () => {
    userimage.image = null;
    userimage.uploadCount = 0;
};

userimage.readImage = id => {
    if (beads.canvas === undefined) return;
    if (modes.currentMode.name === 'browser') menu.returnToCanvas();

    userimage.remove();
    const file = document.querySelector(`#${id}`).files[0];
    b3.store.mySet('userImageFileName', file.name);
    const reader = new FileReader();

    reader.addEventListener('load', () => {
        userimage.uploadCount++;
        game.textures.addBase64('myImage' + userimage.uploadCount.toString(), reader.result);
        setTimeout(() => {
            userimage.displayImage();
        }, 500);
    }, false);

    reader.addEventListener('error', () => {
        console.error('Error reading file');
    });

    if (file) {
        reader.readAsDataURL(file);
    }
};

userimage.triggerUploadImage = () => {
    document.getElementById('load-image').click();
};

userimage.displayImage = () => {
    let x = game.cameras.main.scrollX + 600;
    let y = game.cameras.main.scrollY + 400;

    userimage.image = game.add.sprite(
        x, y, 'myImage' + userimage.uploadCount.toString()
        ).setInteractive().setDepth(1).myIgnore('top');
    game.input.setDraggable(userimage.image);
    const myAngle = settings.pattern?.rotateCamera ? - Math.PI / 2 : 0;

    userimage.image.setRotation(myAngle);
    userimage.image.currentAngle = settings.pattern?.rotateCamera ?
        - Math.PI:
        Math.PI / 2;

    userimage.handle = game.add.ellipse(x, y-(userimage.image.height/2)-50, 20, 20, 0xff0000).setDepth(0.8).setInteractive().myIgnore('top');
    userimage.handle.on('pointerdown', () => {
        modes.start('rotate image');
    });

    userimage.image.on('pointerdown', () => {
        let point = utils.returnPoint(
            game.input.activePointer.position.x,
            game.input.activePointer.position.y
        );

        game.clickPoint = {
            x: point.x - userimage.image.x,
            y: point.y - userimage.image.y
        };
    });

    userimage.updateHandle();
    modes.start('image');
};

userimage.updateHandle = () => {
    userimage.handle.x = userimage.image.x + ((userimage.image.displayHeight/2 + 50) * Math.cos(userimage.image.currentAngle));
    userimage.handle.y = userimage.image.y - ((userimage.image.displayHeight/2 + 50) * Math.sin(userimage.image.currentAngle));
};

userimage.rotateImage = () => {
    if (!game.input.activePointer.isDown) {
        modes.start('image');
        return;
    }

    let myPoint = utils.returnPoint(game.input.activePointer.x, game.input.activePointer.y);
    let xDist = myPoint.x - userimage.image.x;
    let yDist = userimage.image.y - myPoint.y;
    let currentAngle = Math.atan(yDist/xDist);
    if (xDist < 0) {
        currentAngle += Math.PI;
    }
    if (currentAngle < 0) {
        currentAngle += Math.PI * 2;
    }
    userimage.image.currentAngle = currentAngle;
    userimage.updateHandle();
    userimage.image.setAngle(-1 - ((currentAngle - (Math.PI / 2)) * (180 / Math.PI)));
};

userimage.newProject = config => {
    if (!config.keepImage) {
        userimage.remove();
    }
};

userimage.remove = () => {
    if (!userimage.image) return;
    b3.store.mySet('userImageFileName', '');
    userimage.handle.destroy();
    userimage.image.destroy();
    userimage.image = null;
    modes.start('draw');
};
